
<div class="row p-2" style="display: flex;justify-content: space-between;">
  <div *ngIf="showName" class="col-md-7 mat-body-1 displayFlex">
      <span [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
</div>
  <div  id="rating" [ngClass]="{'col-md-4': showName}">
    

    <ngb-rating  class="custom-rating" [max]="maxStars" [(rate)]="starRating" [(ngModel)]="userInputRate" (click)="onClickOfStar()" 
      [ngClass]="{'opacity':IsReadOnly}" [readonly]="IsReadOnly">
    </ngb-rating> 
    <span *ngIf="starRating > 0" class="px-2 mat-body-1">Rated {{starRating}} of {{maxStars}}</span> 

   
    
  </div>
</div>

<div *ngIf="errormgvisible" class="offset-8">
  <div class="mat-body-1 errormsg margin-top" *ngFor="let error of validationerrormessage">{{error}}</div>
 </div>
 
